import React from 'react';
import Text from 'components/Text/Text';
import style from './ViewPageSection.module.scss';

interface IProps {
	heading: string;
	children: React.ReactNode;
}

export const ViewPageSection: React.FC<IProps> = ({ heading, children }) => {
	return (
		<div className={style.container} data-test="ViewPageSection">
			<Text
				className={style.heading}
				translationNameSpace="form"
				translationKey={heading}
				theme="secondary"
				size="s"
				weight="bold"
			/>
			{children}
		</div>
	);
};
